$(document).ready(function(){
  $('.index-slider-carousel').owlCarousel({
    items: 1,
    loop: true,
    nav: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 6000,
    autoplayHoverPause: true,
    navText: [
    '<img src="https://cdn.shopify.com/s/files/1/0679/5549/1006/files/Arrow_Right.svg" alt="Prev" loading="lazy">',
    '<img src="https://cdn.shopify.com/s/files/1/0679/5549/1006/files/Arrow_Left.svg" alt="Next" loading="lazy">'
  ]
  });
});

$(document).ready(function(){
  $('.review-slider-carousel').owlCarousel({
    items: 1,
    loop: true,
    nav: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 6000,
    autoplayHoverPause: true,
    navText: [
    '<img src="https://cdn.shopify.com/s/files/1/0679/5549/1006/files/arrow-right-testinomial.svg" alt="Prev" loading="lazy">',
    '<img src="https://cdn.shopify.com/s/files/1/0679/5549/1006/files/arrow-left-testinomial.svg" alt="Next" loading="lazy">'
  ]
  });
   $(window).scroll(function() {
   AOS.init();
   console.log('animation run');
});
});

